module.exports = __webpack_public_path__ + "static/media/20180825_143831.4ba0ede9.jpg";